import { FC, useCallback, useEffect, useState } from 'react';
import { Invoice, InvoiceItem, InvoiceStatus } from 'types';
import { EditInvoiceItemDialog } from './edit-invoice-item-dialog';
import { InvoiceDetailsList } from './invoice-details-list';

export const InvoiceDetailsTab: FC<{ invoice: Invoice | null; onItemEditSuccess: () => void }> = ({
  invoice,
  onItemEditSuccess
}) => {
  const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([]);
  const [open, setOpen] = useState(false);
  const [dialogKey, setDialogKey] = useState(0);
  const [itemToEdit, setItemToEdit] = useState<InvoiceItem | null>(null);

  const close = useCallback(() => {
    setOpen(false);
    setItemToEdit(null);
    setDialogKey(Math.random());
  }, []);

  // Set and sort invoice items
  useEffect(() => {
    // const items = invoice?.items ?? [];
    const items = invoice?.items.slice() ?? [];
    // Sort items by size type, then unit number, then gate in
    items.sort(
      (a, b) =>
        a.sizeType.localeCompare(b.sizeType) ||
        a.unitNumber.localeCompare(b.unitNumber) ||
        a.gateInDate.getTime() - b.gateInDate.getTime()
    );
    setInvoiceItems(items);
  }, [invoice?.items]);

  return (
    <>
      {itemToEdit && invoice && (
        <EditInvoiceItemDialog
          key={dialogKey}
          open={open}
          close={close}
          invoiceItem={itemToEdit}
          onItemEditSuccess={onItemEditSuccess}
          invoice={invoice}
        />
      )}
      <div className="card-primary raised">
        <div className="card-header">
          <h4 className="">UNIT DETAILS</h4>
        </div>
        <div className='card-body'>
          {invoice?.status === InvoiceStatus.HOLD && (
            <div>
              <h6 className="text-dark font-weight-regular">Hold Reason</h6>
              <p className="text-black">{invoice.statusReason ?? 'N/A'}</p>
            </div>
          )}
        </div>
        <InvoiceDetailsList
          showEdit={!invoice?.finalized}
          invoiceItems={invoiceItems}
          editClicked={(invoiceItem: InvoiceItem) => {
            setItemToEdit(invoiceItem);
            setOpen(true);
          }}
        />
      </div>
    </>
  );
};
